<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline row">
                        <div class="col-xs-12 col-sm-fill col-xl-10 hidden-xs">
                            <h3>
                                <i class="las" :class="$router.currentRoute.meta.icon"></i>
                                {{$router.currentRoute.meta.title}}
                            </h3>
                        </div>
                        <div class="col-xs-12 col-sm-fit col-xl-1">
                            <router-link class="button button-lg color-primary margin-top-10" :to="{'name': 'CadastrarClientes', 'query': {'t': (new Date().getTime())}}" style="width: 100%;">
                                Adicionar <i class="las la-plus-circle"></i>
                            </router-link>
                        </div>
                    </div>

                    <div class="row margin-top-20">
                        <div v-if="$root.user.tipo != 'contratante'" class="col-xl-12 margin-bottom-20">
                            <p class="help">
                                <i class="las la-question-circle"></i>
                                Acompanhe abaixo o relatório completo de clientes, onde é possível filtrar de acordo com sua necessidade.
                            </p>
                        </div>                          
                        <div class="col-xl-12">
                            <form method="get" style="width: 100%;" class="margin-bottom-0" v-on:submit.prevent="form.page = 1;get(true);" novalidate="">
                                <div class="flex-xl-nowrap row">
                                    <div class="col-xs-12 col-md-12 col-lg-6 col-xl-fill">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Pesquisa:</h5>
                                            <input type="text" placeholder="Pesquise um cliente aqui.." required="" class="with-border margin-bottom-0" v-model="form.pesquisa">
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-md-6 col-lg-3">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Categoria:</h5>
                                            <select class="with-border" v-model="form.categoria">
                                                <option value="" disabled selected hidden>Selecione..</option>                              
                                                <option value="CLIENTE DE CONTRATO">Cliente de contrato</option>
                                                <option value="CLIENTE EXTRA">Cliente extra</option>
                                                <!-- <option value="MANUTENÇÃO PREVENTIVA">Manutenção preventiva</option> -->
                                                <!-- <option value="ESCRITÓRIO">Escritório</option> -->
                                                <!-- <option value="CC - ENTREGA DE ENVELOPE">CC - Entrega de envelope</option> -->
                                                <option value="CANCELADO">Cancelado</option>
                                                <option value="PENDÊNCIA FINANCEIRA">Pendência financeira</option>
                                            </select>
                                        </div>
                                    </div>                                    
                                    <div class="col-xs-6 col-md-6 col-lg-3 col-xl-2">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>De:</h5>
                                            <input type="date" required="" class="with-border margin-bottom-0" v-model="form.dataInicio">
                                        </div>
                                    </div>        
                                    <div class="col-xs-6 col-md-6 col-lg-3 col-xl-2">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Até:</h5>
                                            <input type="date" required="" class="with-border margin-bottom-0" v-model="form.dataFinal">
                                        </div>
                                    </div>         
                                    <div class="col-xs-fit align-self-md-end">
                                        <div class="submit-field margin-bottom-10">
                                            <button class="button color-gray" style="height: 50px; width: 100%;">
                                                <i class="las la-search"></i>
                                            </button>  
                                        </div>
                                    </div>                                    
                                </div>
                                <div class="hidden-sm hidden-xl margin-top-20"></div>
                            </form>                         
                        </div>                         
                        
                        <div class="col-xl-12 col-xs-12">
                            <div v-show="data.itens.length == 0 && data.loaded">
                                <center>                           
                                    <img src="static/images/empty.svg" style="width: 300px;">
                                    <h3 class="center" style="line-height: 120%; font-weight: 200">
                                        Nenhum resultado encontrado.
                                    </h3>
                                </center>     
                            </div>   

                            <div class="parent table-scroll margin-top-30" style="overflow-x: auto !important; border: 1px solid #ddd;" v-if="data.itens.length > 0 && data.loaded">
                            <!-- <div class="parent table-scroll margin-top-30" style="overflow-x: auto !important; border: 1px solid #ddd;" v-if="data.loaded"> -->
                                <table class="child table table-bordered  table-responsive table-bordered-default">
                                    <thead>
                                        <th style="min-width: 70px; width: 70px;">
                                            ID
                                        </th>
                                        <th style="min-width: 200px;">
                                            Nome
                                        </th>
                                        <th style="min-width: 220px; width: 220px;">
                                            E-mail
                                        </th>
                                        <th style="min-width: 155px; width: 155px; text-align: center;">
                                            Categoria
                                        </th>                                     
                                        <th style="min-width: 140px; width: 140px; text-align: center;">
                                            Data de criação
                                        </th>
                                        <th style="min-width: 120px; width: 120px; text-align: center;">
                                            Ações
                                        </th>
                                    </thead>
                                    <tbody>   
                                        <tr v-for="(item, index) in data.itens" :key="item.id" v-bind:class="{'bloqueado': item.ativo == -1}">
                                            <td data-label="ID:">
                                                <b>
                                                    #{{item.id}}
                                                </b>
                                            </td>
                                            <td data-label="Nome:" style="">                               
                                                {{item.nome}}
                                                <small class="block" style="color: #888 !important">{{item.empresa}}</small>
                                            </td>   
                                            <td data-label="E-mail:">
                                                {{item.email ? (item.email.replaceAll(",", "\n")) : '-'}}
                                            </td>
                                            <td data-label="Categoria:" style="text-align: center;">
                                                {{!item.categoria ? '-' : ''}}
                                                <span v-if="item.categoria" class="dashboard-status-button color-gray">{{item.categoria}}</span>
                                            </td>                       
                                            <td data-label="Data de criação:" style="text-align: center;">
                                                {{item.datahora | formatDate}}
                                            </td>
                                            <td data-label="Ações:" style="text-align: center;">
                                                <p class="segmented segmented-raised segmented-round">
                                                    <button v-on:click="$root.go('EditarClientes', JSON.stringify({'c': item.cod}))" class="button button-round color-primary">
                                                        <i class="las la-edit"></i>
                                                    </button>
                                                    <button v-if="item.ativo == 1" v-on:click="bloquear(item.cod)" class="button button-round color-orange">
                                                        <i class="las la-ban"></i>
                                                    </button>
                                                    <button v-if="item.ativo == -1" v-on:click="desbloquear(item.cod)" class="button button-round color-orange">
                                                        <i class="las la-check-circle"></i>
                                                    </button>                                                    
                                                    <button v-on:click="del(item.cod)" class="button button-round button-danger color-red">
                                                        <i class="las la-trash"></i>
                                                    </button>
                                                </p>
                                            </td>               
                                        </tr> 
                                    </tbody>
                                </table>
                            </div>

                            <div class="pagination-container margin-top-60 margin-bottom-60">
                                <nav class="pagination">
                                    <ul>
                                        <li class="pagination-arrow" v-show="data.page > 1" v-on:click="form.page = (data.page - 1); get(true);">
                                            <a>
                                                <i class="material-icons">arrow_back</i>
                                                Anterior
                                            </a>
                                        </li>
                                        <li class="pagination-arrow" v-show="data.page >= 1 && data.page < (data.pages.length)" v-on:click="form.page = (data.page + 1); get(true);">
                                            <a>
                                                Próxima
                                                <i class="material-icons">arrow_forward</i>
                                            </a>
                                        </li>    
                                        <br class="hidden-lg hidden-xl hidden-md">                                        
                                        <li v-for="(item, index) in data.pages" v-show="item.show">
                                            <a class="" v-bind:class="{'current-page': item.index == data.page}" v-on:click="form.page = item.index; get(true);">
                                                {{item.index}}
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>

                        </div>
                    </div>            

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Clientes',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },     
    filters: {
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toFixed(2).toLocaleString('pt-br', {minimumFractionDigits: 2});
            } else {
                return "0.00";
            }
        },        
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }
            return date + (time ? (" " + time) : "");
        }
    },        
    data () {
        var self                    = this;
        return {
            "data":                 {
                "itens":            []
            },          
            "_data":                {
                "loaded":           false,
                "itens":            [
                ]
            },
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "categoria":        "",
                "page":             1
            }              
        }
    },
    methods: {             
        get: function(e) {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                axios.get("api/clientes.php", {params: self.form})
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data   = response.data.result; 
                    loading.hide();
                    self.$forceUpdate();
                    resolve(response.data.result);
                    self.$root.scrollTop();                    
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    if (e) loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },
        bloquear: function(cod) {
            console.log("bloquear()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja bloquear?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                form.acao               = "bloquear";
                loading.show();
                
                axios.put("api/clientes.php", form)
                .then(response => {
                    console.log("bloquear() response", response)
                    self.get();
                })
                .catch(error => {
                    console.log("bloquear() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },
        desbloquear: function(cod) {
            console.log("desbloquear()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja desbloquear?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                form.acao               = "bloquear";
                loading.show();
                
                axios.put("api/clientes.php", form)
                .then(response => {
                    console.log("desbloquear() response", response)
                    self.get();
                })
                .catch(error => {
                    console.log("desbloquear() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },        
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                loading.show();
                
                axios.delete("api/clientes.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    self.get();
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        }                           
    },
    created: function() {
        var self = this;
    },
    activated: function() {
        var self = this;

        loading.show();
        self.get(true).then(function() {              
            loading.hide();
        }).catch(function(error) {
            console.log("erro ao buscar", error);
            loading.hide();
        });
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .bloqueado {
        opacity: 0.5 !important;
    }

    .card .dashboard-status-button {
        margin-top: 8px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Clientes.vue